import { TFunction } from "i18next"

export const getProvinceIneOptions = (t: TFunction) => [
  {
    label: t("dropdownProvinces.provincia_01"),
    value: "01",
  },
  {
    label: t("dropdownProvinces.provincia_02"),
    value: "02",
  },
  {
    label: t("dropdownProvinces.provincia_03"),
    value: "03",
  },
  {
    label: t("dropdownProvinces.provincia_04"),
    value: "04",
  },
  {
    label: t("dropdownProvinces.provincia_05"),
    value: "05",
  },
  {
    label: t("dropdownProvinces.provincia_06"),
    value: "06",
  },
  {
    label: t("dropdownProvinces.provincia_07"),
    value: "07",
  },
  {
    label: t("dropdownProvinces.provincia_08"),
    value: "08",
  },
  {
    label: t("dropdownProvinces.provincia_09"),
    value: "09",
  },
  {
    label: t("dropdownProvinces.provincia_10"),
    value: "10",
  },
  {
    label: t("dropdownProvinces.provincia_11"),
    value: "11",
  },
  {
    label: t("dropdownProvinces.provincia_12"),
    value: "12",
  },
  {
    label: t("dropdownProvinces.provincia_51"),
    value: "51",
  },
  {
    label: t("dropdownProvinces.provincia_13"),
    value: "13",
  },
  {
    label: t("dropdownProvinces.provincia_14"),
    value: "14",
  },
  {
    label: t("dropdownProvinces.provincia_15"),
    value: "15",
  },
  {
    label: t("dropdownProvinces.provincia_16"),
    value: "16",
  },
  {
    label: t("dropdownProvinces.provincia_17"),
    value: "17",
  },
  {
    label: t("dropdownProvinces.provincia_18"),
    value: "18",
  },
  {
    label: t("dropdownProvinces.provincia_19"),
    value: "19",
  },
  {
    label: t("dropdownProvinces.provincia_20"),
    value: "20",
  },
  {
    label: t("dropdownProvinces.provincia_21"),
    value: "21",
  },
  {
    label: t("dropdownProvinces.provincia_22"),
    value: "22",
  },
  {
    label: t("dropdownProvinces.provincia_23"),
    value: "23",
  },
  {
    label: t("dropdownProvinces.provincia_24"),
    value: "24",
  },
  {
    label: t("dropdownProvinces.provincia_25"),
    value: "25",
  },
  {
    label: t("dropdownProvinces.provincia_26"),
    value: "26",
  },
  {
    label: t("dropdownProvinces.provincia_27"),
    value: "27",
  },
  {
    label: t("dropdownProvinces.provincia_28"),
    value: "28",
  },
  {
    label: t("dropdownProvinces.provincia_29"),
    value: "29",
  },
  {
    label: t("dropdownProvinces.provincia_52"),
    value: "52",
  },
  {
    label: t("dropdownProvinces.provincia_30"),
    value: "30",
  },
  {
    label: t("dropdownProvinces.provincia_31"),
    value: "31",
  },
  {
    label: t("dropdownProvinces.provincia_32"),
    value: "32",
  },
  {
    label: t("dropdownProvinces.provincia_33"),
    value: "33",
  },
  {
    label: t("dropdownProvinces.provincia_34"),
    value: "34",
  },
  {
    label: t("dropdownProvinces.provincia_35"),
    value: "35",
  },
  {
    label: t("dropdownProvinces.provincia_36"),
    value: "36",
  },
  {
    label: t("dropdownProvinces.provincia_37"),
    value: "37",
  },
  {
    label: t("dropdownProvinces.provincia_38"),
    value: "38",
  },
  {
    label: t("dropdownProvinces.provincia_39"),
    value: "39",
  },
  {
    label: t("dropdownProvinces.provincia_40"),
    value: "40",
  },
  {
    label: t("dropdownProvinces.provincia_41"),
    value: "41",
  },
  {
    label: t("dropdownProvinces.provincia_42"),
    value: "42",
  },
  {
    label: t("dropdownProvinces.provincia_43"),
    value: "43",
  },
  {
    label: t("dropdownProvinces.provincia_44"),
    value: "44",
  },
  {
    label: t("dropdownProvinces.provincia_45"),
    value: "45",
  },
  {
    label: t("dropdownProvinces.provincia_46"),
    value: "46",
  },
  {
    label: t("dropdownProvinces.provincia_47"),
    value: "47",
  },
  {
    label: t("dropdownProvinces.provincia_48"),
    value: "48",
  },
  {
    label: t("dropdownProvinces.provincia_49"),
    value: "49",
  },
  {
    label: t("dropdownProvinces.provincia_50"),
    value: "50",
  },
]
